import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, BaixarArquivos } from './types';

export const INITIAL_STATE: BaixarArquivos = {
	status: 0,
	data: {
		arquivo: null,
	},
	instanceRequest: null,
	base64: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): BaixarArquivos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.BAIXAR_ARQUIVOS_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.instanceRequest = action.payload.instanceRequest;
				draft.base64 = INITIAL_STATE.base64;
				break;
			}

			case Types.BAIXAR_ARQUIVOS_SUCCESS: {
				draft.status = 200;
				draft.data.arquivo = action.payload.response;
				draft.instanceRequest = action.payload.instanceRequest;
				draft.base64 = action.payload.base64;
				break;
			}

			case Types.BAIXAR_ARQUIVOS_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				draft.instanceRequest = action.payload.instanceRequest;
				draft.base64 = INITIAL_STATE.base64;
				break;
			}
			case Types.BAIXAR_ARQUIVOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.instanceRequest = INITIAL_STATE.instanceRequest;
				draft.base64 = INITIAL_STATE.base64;

				break;
			}

			default:
		}
	});
}
